import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, MapPin, Phone, Mail, Clock } from 'lucide-react';
import { Container } from './Container';
export function Footer() {
  return <footer className="bg-[#111827] text-gray-300 pt-16 pb-8 border-t-4 border-pts-red" data-id="element-19">
      <Container data-id="element-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-21">
          {/* Brand & Contact */}
          <div className="space-y-6" data-id="element-22">
            <img src="https://cdn.magicpatterns.com/uploads/gWFT4ncmNMgwJGpFpp5fGQ/PTS-logo-clean-black-transparent.png" alt="Primetime Sports Apparel" className="h-12 w-auto brightness-0 invert" data-id="element-23" />
            <p className="text-sm text-gray-400" data-id="element-24">
              Custom Team Uniforms Without the Ordering Stress. Factory-direct
              quality, unbeatable pricing, and dedicated support.
            </p>
            <div className="space-y-3 text-sm" data-id="element-25">
              <div className="flex items-start" data-id="element-26">
                <MapPin className="h-5 w-5 mr-3 text-pts-red flex-shrink-0 mt-0.5" data-id="element-27" />
                <span data-id="element-28">
                  9229 Southampton Place
                  <br data-id="element-29" />
                  Boca Raton, Florida 33434
                </span>
              </div>
              <div className="flex items-center" data-id="element-30">
                <Phone className="h-5 w-5 mr-3 text-pts-red flex-shrink-0" data-id="element-31" />
                <a href="tel:8882188647" className="hover:text-white transition-colors font-bold" data-id="element-32">
                  888.218.8647
                </a>
              </div>
              <div className="flex items-center" data-id="element-33">
                <Mail className="h-5 w-5 mr-3 text-pts-red flex-shrink-0" data-id="element-34" />
                <a href="mailto:savemoney@getcustomuniforms.com" className="hover:text-white transition-colors" data-id="element-35">
                  savemoney@getcustomuniforms.com
                </a>
              </div>
              <div className="flex items-start" data-id="element-36">
                <Clock className="h-5 w-5 mr-3 text-pts-red flex-shrink-0 mt-0.5" data-id="element-37" />
                <span data-id="element-38">
                  Monday – Friday
                  <br data-id="element-39" />
                  9am – 7pm EST
                </span>
              </div>
            </div>
          </div>

          {/* Sports */}
          <div data-id="element-40">
            <h4 className="text-white font-oswald font-bold text-lg tracking-wide mb-6 uppercase" data-id="element-41">
              Sports
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-42">
              <li data-id="element-43">
                <Link to="/sports/baseball" className="hover:text-pts-red transition-colors" data-id="element-44">
                  Baseball
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/sports/basketball" className="hover:text-pts-red transition-colors" data-id="element-46">
                  Basketball
                </Link>
              </li>
              <li data-id="element-47">
                <Link to="/sports/football" className="hover:text-pts-red transition-colors" data-id="element-48">
                  Football
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/sports/softball" className="hover:text-pts-red transition-colors" data-id="element-50">
                  Softball
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/sports/soccer" className="hover:text-pts-red transition-colors" data-id="element-52">
                  Soccer
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/sports/cheer" className="hover:text-pts-red transition-colors" data-id="element-54">
                  Cheer
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/sports/volleyball" className="hover:text-pts-red transition-colors" data-id="element-56">
                  Volleyball
                </Link>
              </li>
              <li data-id="element-57">
                <Link to="/sports/track-field" className="hover:text-pts-red transition-colors" data-id="element-58">
                  Track & Field
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div data-id="element-59">
            <h4 className="text-white font-oswald font-bold text-lg tracking-wide mb-6 uppercase" data-id="element-60">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-61">
              <li data-id="element-62">
                <Link to="/team-stores" className="hover:text-pts-red transition-colors" data-id="element-63">
                  Team Stores
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/process" className="hover:text-pts-red transition-colors" data-id="element-65">
                  Our Process
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/about" className="hover:text-pts-red transition-colors" data-id="element-67">
                  About Us
                </Link>
              </li>
              <li data-id="element-68">
                <Link to="/contact" className="hover:text-pts-red transition-colors" data-id="element-69">
                  Contact
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/get-started" className="hover:text-pts-red transition-colors font-bold text-white" data-id="element-71">
                  Start an Order
                </Link>
              </li>
              <li data-id="element-72">
                <Link to="/my-account" className="hover:text-pts-red transition-colors" data-id="element-73">
                  My Account
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div data-id="element-74">
            <h4 className="text-white font-oswald font-bold text-lg tracking-wide mb-6 uppercase" data-id="element-75">
              Connect
            </h4>
            <div className="flex space-x-4 mb-8" data-id="element-76">
              <a href="#" className="bg-gray-800 p-2 rounded hover:bg-pts-red hover:text-white transition-colors" data-id="element-77">
                <Facebook className="h-5 w-5" data-id="element-78" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded hover:bg-pts-red hover:text-white transition-colors" data-id="element-79">
                <Instagram className="h-5 w-5" data-id="element-80" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded hover:bg-pts-red hover:text-white transition-colors" data-id="element-81">
                <Twitter className="h-5 w-5" data-id="element-82" />
              </a>
            </div>

            <div className="bg-gray-800 p-5 rounded border border-gray-700" data-id="element-83">
              <h5 className="text-white font-bold mb-2" data-id="element-84">Have a Quote?</h5>
              <p className="text-sm text-gray-400 mb-4" data-id="element-85">
                Send it to us and we'll beat it. Factory direct pricing
                guaranteed.
              </p>
              <Link to="/contact" className="inline-block border border-pts-red text-pts-red hover:bg-pts-red hover:text-white px-4 py-2 rounded text-sm font-bold transition-colors w-full text-center" data-id="element-86">
                Send Us Your Quote
              </Link>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-87">
          <p data-id="element-88">
            &copy; {new Date().getFullYear()} Primetime Sports Apparel. All
            rights reserved.
          </p>
          <div className="flex space-x-4 mt-4 md:mt-0" data-id="element-89">
            <Link to="/privacy" className="hover:text-gray-300" data-id="element-90">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-gray-300" data-id="element-91">
              Terms of Service
            </Link>
            <a href="https://customuniformsupplier.com" target="_blank" rel="noopener noreferrer" className="hover:text-gray-300" data-id="element-92">
              Wholesale
            </a>
          </div>
        </div>
      </Container>
    </footer>;
}